module.exports = __webpack_public_path__ + "static/media/Soybean5V6-V8.5a3ad3be.PNG";